/**
* @name: index
* @author: weiyong
* @date: 2022-10-26 22:14
* @description：index
* @update: 2022-10-26 22:14
*/
<template>
  <div
    :style="[formElComSty,elCtlStyle]"
    :class="formElComClass"
    v-if="(vuex['showCtl']+'')!=='false'&&(props.show!==false)"
    class="xmInput flowCheckOpinion">
    <div class="flowCheckOpinionRow">
      <a-form-item
        label="审批结论"
        name="opinionIdea"
      >
        <a-radio-group v-model:value="opinionIdea" name="radioGroup" style="position: relative;top:4px;">
          <a-radio value="同意">同意</a-radio>
          <a-radio value="不同意">不同意</a-radio>
        </a-radio-group>
      </a-form-item>
    </div>
    <div class="flowCheckOpinionRow">
      <a-form-item
        label="审批意见"
        name="opinion"
      >
        <div class="flow-opinion-field">
          <a-textarea
            v-model:value="opinionValue"
            placeholder="请输入审批意见"
            allow-clear
            :maxlength="200"
            :auto-size="{ minRows: 2, maxRows: 5 }"
          />
          <span class="flow-opinion-count">{{ opinionCount }}/200</span>
        </div>
      </a-form-item>
    </div>

    <div class="flowCheckOpinionRow" v-if="props.checkFile">
      <a-form-item
        label="审批附件"
        name="opinion"
      >
        <xm-file-upload :showLabel="false" :filetype="nodeFileId" :pModelObj="state" :model="{key:'processInstanceId'}" :props="{}"/>
      </a-form-item>
    </div>

    <el-remark :props="props"/>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "flowCheckOpinionCtl",
});
</script>

<script lang="ts" setup>
import XmFileUpload  from "@/main-page-form/ctls/fileCtls/xmFileUpload/index.vue";
import {RadioGroup as ARadioGroup,Radio as ARadio,FormItem as AFormItem,Textarea as ATextarea} from 'ant-design-vue';
import {usePageModelsStore} from "@/store/modules/pageModels";
import {useCtlStyle} from "@/main-page/hooks/useCtlStyle";
import {useComElState} from "@/main-page/ctls/hooks/useComElState";
import {useVuexState} from "@/main-page/ctls/hooks/useVuexState";
import {useInputChangeHook} from "@/main-page/ctls/hooks/useInputChangeHook";
import {CtlComEnum} from "@/main-page/enums/ctlComEnum";
import {GoingNewUtils} from "xmgoing-utils";
import ElRemark from "@/main-page-form/common/el-remark.vue";
import {defineEmits} from "vue";
import {storeToRefs} from "pinia";


const pageModelsStore: any = usePageModelsStore();
const {state} = storeToRefs(pageModelsStore);

interface propTypes {
  initDefValFlag:string;
  props: any,
  events: any,
  readOnlyText: boolean,
  styles: any,
  showLabel: boolean,
  model: any,
  pItemFormKey: string,
  pModelObj: any,
  pItemType:string;
  pItem: string,
}

const propsPage = withDefaults(defineProps<propTypes>(), {
  readOnlyText: false,
  showLabel: true,
  pItem: '',
  pItemType:'',
  styles: {},
  initDefValFlag:'',
  pItemFormKey: '',
  events: [],
  props: {},
  pModelObj: {},
  model: {},
});
const {initDefValFlag, pModelObj}: any = toRefs(propsPage);
const {styles, model, events, props,pItem}=propsPage
const {vuex} = useVuexState({sectionConfig: props, vuexProps: ['showCtl', 'disabled', CtlComEnum.DEFAULT_SET]});
const emits = defineEmits(['pressEnter','change'])
const pressEnter = function () {
  emits('pressEnter', {value: unref(pModelObj)[unref(model).key]})
}
const {changeInput} = useInputChangeHook({emits,props, events, model, formObj: pModelObj});

const getDefPlaceholder = computed(() => {
  return '请输入' + (unref(props).label || unref(props).propName);
})
const {elCtlStyle, elBaseStyle, formElComClass, formElComSty} = useCtlStyle({
  styles,
  props,
  propsStyl: unref(pItem) === 'xmForm' ? [] : ['width'],
  outExtendProp: unref(pItem) === 'xmForm' ? ['marginLeft', 'marginTop', 'marginRight', 'marginBottom', 'paddingLeft'] : []
});
const maxOpinionLength = 200;
const opinionIdea=ref('同意');
const opinionValue=ref('');
const opinionCount = computed(() => Array.from(opinionValue.value || '').length);
const nodeFileId=ref('');
const flowId=GoingNewUtils.getUUChar(20);

unref(state)['opinionIdea']=opinionIdea;
unref(state)['opinionValue']=opinionValue;
nodeFileId.value=GoingNewUtils.getUUChar(20);
unref(state)['nodeFileId']=unref(nodeFileId);

watch(()=>unref(opinionIdea),()=>{
  unref(state)['opinionIdea']=opinionIdea;
})
watch(()=>unref(opinionValue),()=>{
  unref(state)['opinionValue']=opinionValue;
})
</script>

<style type="text/css" lang="less">
.xmForm.readOnlyText .xmInput.flowCheckOpinion .ant-input-affix-wrapper{
  background: #FFF;
  textarea{
    background: #FFF;
  }
}
.xmFormGroupPanelDiv .flowCheckOpinion .ant-form-item{
  margin-bottom: 4px;
}
.flowCheckOpinionRow{
  padding:4px 12px;
}
.flowCheckOpinion .flow-opinion-field{
  position: relative;
}
.flowCheckOpinion .flow-opinion-field textarea.ant-input{
  padding-bottom: 22px;
}
.flowCheckOpinion .flow-opinion-count{
  position: absolute;
  right: 8px;
  bottom: 4px;
  z-index: 2;
  height: 16px;
  line-height: 16px;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.45);
  background: #fff;
  pointer-events: none;
}
</style>
